import "./KitchenRemodeling.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Inclusions from "./sections/Inclusions";
import Gallery from "./sections/Gallery";
import Timeline from "./sections/Timeline";
import Faqs from "./sections/Faqs";
import Action from "./sections/Action";
import Footer from "@/reusable_sections/Footer";
import KitchenProjectCtaBand from "./sections/KitchenProjectCtaBand";
import EstimateRequestForm from "./sections/EstimateRequestForm";
export default function KitchenRemodelingPage() {
  return <div>
      <Header />
      <Hero />
      <Inclusions />
      <KitchenProjectCtaBand />
      <Gallery />
      <Timeline />
      <Faqs />
      <EstimateRequestForm />
      <Action />
      <Footer />
    </div>;
}